/**
 * Stable CSS class names for E2E — Fast delivery cargo management.
 */
export const FDCM = {
    page: 'fast-delivery-cargo-management-page',
    mainGrid: 'fast-delivery-cargo-management-page__main-grid',
    breadcrumbSection: 'fast-delivery-cargo-management-page__breadcrumb-section',
    breadcrumbWrap: 'fast-delivery-cargo-management-page__breadcrumb-wrap',
    contentSection: 'fast-delivery-cargo-management-page__content-section',
    loadingSection: 'fast-delivery-cargo-management-page__loading-section',

    emptyStateWrap: 'fast-delivery-cargo-management-page__empty-state',
    shippingCompanyFieldWrap: 'fast-delivery-cargo-management-page__shipping-company-field',
    inputSelectShippingCompany: 'fast-delivery-cargo-management-page-input--select-shipping-company',
    inputButtonFilter: 'fast-delivery-cargo-management-page-input--button-filter',

    tabsWrap: 'fast-delivery-cargo-management-page__tabs-wrap',
    tabsRoot: 'fast-delivery-cargo-management-page__tabs',
    tabDeliveryList: 'fast-delivery-cargo-management-page-input--tab-delivery-list',
    tabBulkUpload: 'fast-delivery-cargo-management-page-input--tab-bulk-upload',

    listToolbarWrap: 'fast-delivery-cargo-management-page__list-toolbar',
    inputButtonAddNew: 'fast-delivery-cargo-management-page-input--button-add-new',
    exportExcelWrap: 'fast-delivery-cargo-management-page__export-excel-wrap',

    bulkResultsWrap: 'fast-delivery-cargo-management-page__bulk-results',
    bulkExportWrap: 'fast-delivery-cargo-management-page__bulk-export-wrap',
    bulkResultsGridWrap: 'fast-delivery-cargo-management-page__bulk-results-grid',

    deliveryTablePaper: 'fast-delivery-cargo-management-page__delivery-table-paper',
    inputSwitchTomorrowDeliveryCell: 'fast-delivery-cargo-management-page-input--switch-tomorrow-delivery',
    inputSwitchExpressDeliveryCell: 'fast-delivery-cargo-management-page-input--switch-express-delivery',
    inputSwitchTodayDeliveryCell: 'fast-delivery-cargo-management-page-input--switch-today-delivery',
    inputButtonEditRow: 'fast-delivery-cargo-management-page-input--button-edit-row',
    tablePagination: 'fast-delivery-cargo-management-page-input--table-pagination',

    bulkUploadSection: 'fast-delivery-cargo-management-page__bulk-upload-section',
    bulkUploadExampleWrap: 'fast-delivery-cargo-management-page__bulk-upload-example-wrap',
    bulkUploadDropzone: 'fast-delivery-cargo-management-page__bulk-upload-dropzone',
    inputFileExcel: 'fast-delivery-cargo-management-page-input--file-excel',
    inputButtonSelectExcelFile: 'fast-delivery-cargo-management-page-input--button-select-excel-file',
    inputButtonUploadExcel: 'fast-delivery-cargo-management-page-input--button-upload-excel',

    addDrawerRoot: 'fast-delivery-cargo-management-add-drawer',
    addDrawerContent: 'fast-delivery-cargo-management-add-drawer__content',
    addDrawerHeader: 'fast-delivery-cargo-management-add-drawer__header',
    inputButtonCloseAddDrawer: 'fast-delivery-cargo-management-add-drawer-input--button-close',
    addShippingCompanyFieldWrap: 'fast-delivery-cargo-management-add-drawer__shipping-company-field',
    inputSelectAddShippingCompany: 'fast-delivery-cargo-management-add-drawer-input--select-shipping-company',
    addCityFieldWrap: 'fast-delivery-cargo-management-add-drawer__city-field',
    inputSelectAddCity: 'fast-delivery-cargo-management-add-drawer-input--select-city',
    addDistrictFieldWrap: 'fast-delivery-cargo-management-add-drawer__district-field',
    inputSelectAddDistrict: 'fast-delivery-cargo-management-add-drawer-input--select-district',
    addNeighborhoodFieldWrap: 'fast-delivery-cargo-management-add-drawer__neighborhood-field',
    inputSelectAddNeighborhood: 'fast-delivery-cargo-management-add-drawer-input--select-neighborhood',
    inputSwitchAddTomorrowDelivery: 'fast-delivery-cargo-management-add-drawer-input--switch-tomorrow-delivery',
    inputSwitchAddExpressDelivery: 'fast-delivery-cargo-management-add-drawer-input--switch-express-delivery',
    inputSwitchAddTodayDelivery: 'fast-delivery-cargo-management-add-drawer-input--switch-today-delivery',
    addDrawerActionsWrap: 'fast-delivery-cargo-management-add-drawer__actions',
    inputButtonAddCancel: 'fast-delivery-cargo-management-add-drawer-input--button-cancel',
    inputButtonAddSave: 'fast-delivery-cargo-management-add-drawer-input--button-save',

    editDrawerRoot: 'fast-delivery-cargo-management-edit-drawer',
    editDrawerHeader: 'fast-delivery-cargo-management-edit-drawer__header',
    inputButtonCloseEditDrawer: 'fast-delivery-cargo-management-edit-drawer-input--button-close',
    editDrawerBody: 'fast-delivery-cargo-management-edit-drawer__body',
    editDrawerFooter: 'fast-delivery-cargo-management-edit-drawer__footer',
    inputSwitchEditTomorrowDelivery: 'fast-delivery-cargo-management-edit-drawer-input--switch-tomorrow-delivery',
    inputSwitchEditExpressDelivery: 'fast-delivery-cargo-management-edit-drawer-input--switch-express-delivery',
    inputSwitchEditTodayDelivery: 'fast-delivery-cargo-management-edit-drawer-input--switch-today-delivery',
    inputButtonEditCancel: 'fast-delivery-cargo-management-edit-drawer-input--button-cancel',
    inputButtonEditSave: 'fast-delivery-cargo-management-edit-drawer-input--button-save',
} as const;

export const fdcmCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
